// extracted by mini-css-extract-plugin
export default {"shadowed":"Navbar_shadowed__5-Ji8","active":"Navbar_active__MZ1RB","link":"Navbar_link__aQ9fA"};